'use client';

import { useAuthenticatedContext } from '@/app/components/Provider';
import { isGuestUser, isMainUser } from '@/app/utils/entities/user';
import { CompleteProfileBannerForm } from '~/components/commons/CompleteProfileBanner/CompleteProfileBannerForm';
import { SignUpGuestBanner } from './SignUpGuestBanner/SignUpGuestBanner';

export const CrossSellWrapper = ({ children }) => {
  const { user } = useAuthenticatedContext();

  return (
    <>
      {isMainUser(user) && <CompleteProfileBannerForm user={user} />}
      {isGuestUser(user) && <SignUpGuestBanner />}
      {children}
    </>
  );
};
